/* Sanitizado del HTML que genera el editor de la descripción (react-quill:
 * títulos, negrita, cursiva, subrayado, listas y links).
 *
 * Se parsea con DOMParser, que arma un documento inerte: no corre scripts ni
 * carga imágenes, así que un <img onerror> no se ejecuta al analizarlo (con
 * div.innerHTML sí). Después se deja sólo lo de la lista blanca: etiquetas
 * conocidas y, de los atributos, únicamente href en los links (con un
 * protocolo seguro) y el tipo de lista de quill. */

const ETIQUETAS_PERMITIDAS = new Set([
  "P", "BR", "STRONG", "EM", "U", "B", "I", "H1", "H2", "OL", "UL", "LI", "A",
]);

// se eliminan con todo su contenido; el resto de lo no permitido se desarma
// y se conserva el texto
const ETIQUETAS_PELIGROSAS = new Set([
  "SCRIPT", "STYLE", "IFRAME", "OBJECT", "EMBED", "SVG", "MATH", "TEMPLATE",
  "NOSCRIPT", "TEXTAREA", "SELECT", "BUTTON", "INPUT", "FORM", "LINK", "META",
]);

const hrefSeguro = (href) => {
  try {
    const url = new URL(href, window.location.origin);
    return ["http:", "https:", "mailto:"].includes(url.protocol);
  } catch {
    return false;
  }
};

const limpiarNodo = (nodo) => {
  Array.from(nodo.childNodes).forEach((hijo) => {
    if (hijo.nodeType === Node.TEXT_NODE) return;

    if (hijo.nodeType !== Node.ELEMENT_NODE) {
      hijo.remove(); // comentarios y demás
      return;
    }

    const etiqueta = hijo.nodeName.toUpperCase();

    if (ETIQUETAS_PELIGROSAS.has(etiqueta)) {
      hijo.remove();
      return;
    }

    limpiarNodo(hijo);

    if (!ETIQUETAS_PERMITIDAS.has(etiqueta)) {
      hijo.replaceWith(...hijo.childNodes);
      return;
    }

    const href = etiqueta === "A" ? hijo.getAttribute("href") : null;
    // quill 2 guarda las viñetas como <ol><li data-list="bullet">
    const tipoLista = etiqueta === "LI" ? hijo.getAttribute("data-list") : null;
    Array.from(hijo.attributes).forEach((attr) => hijo.removeAttribute(attr.name));

    if (tipoLista === "bullet" || tipoLista === "ordered") {
      hijo.setAttribute("data-list", tipoLista);
    }

    if (etiqueta === "A") {
      if (href && hrefSeguro(href)) {
        hijo.setAttribute("href", href);
        hijo.setAttribute("target", "_blank");
        hijo.setAttribute("rel", "noopener noreferrer nofollow");
      }
    }
  });
};

export const sanitizarHtml = (html) => {
  if (!html) return "";
  const doc = new DOMParser().parseFromString(String(html), "text/html");
  limpiarNodo(doc.body);
  return doc.body.innerHTML;
};
